(function () {
	'use strict';

	angular.module('mx.components').component('mxRepeater', {
		bindings: {
			entities: '=',
			templateId: '@',
			orderBy: '@',
			reverse: '<?',
			parentControllerAs: '@',
		},
		templateUrl: 'mx-repeater/mx-repeater.html',
		controller: MxRepeaterCtrl,
		controllerAs: '__$vm',
	});

	MxRepeaterCtrl.$inject = ['$scope'];

	function MxRepeaterCtrl($scope) {
		const __$vm = this;

		__$vm.$onInit = function () {
			initScope();
		};

		function initScope() {
			if (__$vm.parentControllerAs) {
				$scope[__$vm.parentControllerAs] = $scope.$parent[__$vm.parentControllerAs];
			} else {
				$scope.dataModel = $scope.$parent;
			}
		}
	}
})();
